module.exports = __webpack_public_path__ + "mainassets/img/graf1-2.d3eef059.svg";